import { render, staticRenderFns } from "./PaymentAuthorization.vue?vue&type=template&id=254651ab&scoped=true&"
import script from "./PaymentAuthorization.vue?vue&type=script&lang=js&"
export * from "./PaymentAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAuthorization.vue?vue&type=style&index=0&id=254651ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254651ab",
  null
  
)

export default component.exports